var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16839_113108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25333 12.2003C1.91133 12.2003 0.813334 11.1023 0.813334 9.76029V4.06695C0.813334 2.72495 1.91133 1.62695 3.25333 1.62695H6.91333C7.15733 1.62695 7.32 1.78962 7.32 2.03362C7.32 2.27762 7.15733 2.44029 6.91333 2.44029H3.25333C2.35867 2.44029 1.62667 3.17229 1.62667 4.06695V9.76029C1.62667 10.655 2.35867 11.387 3.25333 11.387H8.94667C9.84133 11.387 10.5733 10.655 10.5733 9.76029V5.69362C10.5733 5.44962 10.736 5.28695 10.98 5.28695C11.224 5.28695 11.3867 5.44962 11.3867 5.69362V9.76029C11.3867 11.1023 10.2887 12.2003 8.94667 12.2003H3.25333Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03244 5.98092C6.87363 5.8221 6.87363 5.56462 7.03244 5.4058L11.9124 0.525803C12.0713 0.36699 12.3287 0.36699 12.4876 0.525803C12.6464 0.684616 12.6464 0.942103 12.4876 1.10092L7.60756 5.98092C7.44874 6.13973 7.19126 6.13973 7.03244 5.98092Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54 0.405942L12.2 0.405942C12.4246 0.405942 12.6067 0.588013 12.6067 0.812609V4.47261C12.6067 4.6972 12.4246 4.87928 12.2 4.87928C11.9754 4.87928 11.7933 4.6972 11.7933 4.47261L11.7933 1.79439L8.42089 5.16683L7.84578 4.59172L11.2182 1.21928L8.54 1.21928C8.31541 1.21928 8.13333 1.0372 8.13333 0.812609C8.13333 0.588013 8.31541 0.405942 8.54 0.405942Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16839_113108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0133,
    height: 13.0133,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d53e6aced42247ab9a2c4adf86752092.svg";
export { ForwardRef as ReactComponent };